import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-table/react-table.css";

import { isMultiColorActive, defaultColor,themeColorStorageKey,isDarkSwitchActive } from "./constants/defaultValues";

// Sanitize stored theme color to avoid importing a non-existent SCSS (e.g. light.payvay)
const allowedColors = [
  "light.purple","light.blue","light.green","light.orange","light.red",
  "dark.purple","dark.blue","dark.green","dark.orange","dark.red"
];

let storedColor = (isMultiColorActive || isDarkSwitchActive) ? localStorage.getItem(themeColorStorageKey) : null;
let color = storedColor ? storedColor : defaultColor;
if (!allowedColors.includes(color)) {
  color = defaultColor;
  localStorage.setItem(themeColorStorageKey, color); // reset invalid stored value
} else {
  localStorage.setItem(themeColorStorageKey, color);
}

// Engineered Fix - Only option till Now...
if (color.toString().includes("dark")) document.body.style.backgroundColor = "#1b191b";
else document.body.style.backgroundColor = "#f8f8f8";

let render = () => {
  import('./assets/css/sass/themes/gogo.' + color + '.scss').then(x => {
     require('./AppRenderer');
  });
};
render();